import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {ConfigService, initializeSentry} from '@q9elements/ui-kit/common';

import {AppModule} from './app/app.module';

if (ConfigService.environment.production) {
  enableProdMode();
  initializeSentry();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
